import React, { useEffect } from 'react';
import { AuthProvider } from './contexts/AuthContext';
import AppRouter from './components/AppRouter';
import { initializeRoomCleanupService } from './utils/roomManager';

function App() {
  useEffect(() => {
    // Initialize room cleanup service
    initializeRoomCleanupService();
  }, []);

  return (
    <AuthProvider>
      <AppRouter />
    </AuthProvider>
  );
}

export default App;
